/* An equivalent swap, shown where the item is (commerce/swaps.py; Harry, 16 Oct 2026: "maybe you
   could show that equivalent swap"). The shop records on the hamper which item stands in for which
   (metafield adm.swaps, written into the page by the theme as #adm-swaps). This puts the stand-in in
   the original's card, list line and detail view, says so on each, and adds one line above the
   contents. It runs before the dialog below reads #ingredients-data, so the dialog shows the swap too. */
(() => {
  const src=document.getElementById('adm-swaps');
  if(!src) return;
  let swaps=[];
  try{swaps=(JSON.parse(src.textContent)||{}).swaps||[];}catch(e){return;}
  const data=document.getElementById('ingredients-data');
  const parsed=data?JSON.parse(data.textContent):null;
  const esc=s=>String(s??'').replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  const shown=[];
  for(const s of swaps){
    const from=String(s.from&&s.from.variant_id||''), to=s.to||{};
    if(!from||!to.name) continue;
    const card=document.querySelector('.product-card[data-variant-id="'+from+'"]');
    const line=document.querySelector('.contents-short li[data-variant-id="'+from+'"]');
    if(!card&&!line) continue;
    const amount=(to.size?to.size+' · ':'')+(s.quantity>1?s.quantity+' included':'One included');
    const was='In place of '+(s.from.name||'the original');
    if(card){
      card.classList.add('is-swapped');card.dataset.variantId=String(to.variant_id);
      const a=card.querySelector('a.ingredient-card'), img=card.querySelector('img');
      if(a){a.href=to.image||a.href;a.setAttribute('aria-label','Discover '+to.name+', swapped in for '+(s.from.name||'the original'));}
      if(img){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=to.image||img.src;img.alt=to.name;}
      const pic=card.querySelector('.product-image');
      if(pic&&!pic.querySelector('.swap-tag'))pic.insertAdjacentHTML('afterbegin','<span class="swap-tag">Swapped in</span>');
      const h=card.querySelector('h3');if(h)h.textContent=to.name;
      const p=card.querySelector('h3+p');if(p)p.textContent=amount;
      if(h&&!card.querySelector('.swap-was'))h.insertAdjacentHTML('beforebegin','<p class="swap-was">'+esc(was)+'</p>');
      const fb=card.querySelector('.ingredient-fallback');if(fb&&to.description)fb.textContent=to.description;
      const i=a?Number(a.dataset.ingredient):NaN;
      if(parsed&&parsed.items[i])Object.assign(parsed.items[i],{handle:to.handle||parsed.items[i].handle,name:to.name,maker:'',amount,
        description:(to.description?to.description+' ':'')+was+', which is unavailable just now.',image:to.image,thumb:to.image,kind:'swap'});
    }
    if(line){
      line.classList.add('is-swapped');line.dataset.variantId=String(to.variant_id);
      const spans=line.querySelectorAll(':scope>span');
      const name=spans[0]&&(spans[0].querySelector('a')||spans[0]);
      if(name)name.textContent=to.name;
      if(spans[0]&&!line.querySelector('.swap-was'))spans[0].insertAdjacentHTML('beforeend',' <small class="swap-was">'+esc(was.toLowerCase())+'</small>');
      if(spans[1])spans[1].textContent=to.size||'';
    }
    shown.push({from:s.from.name,to:to.name});
  }
  if(parsed&&data)data.textContent=JSON.stringify(parsed);
  if(!shown.length) return;
  const head=document.querySelector('.concept-contents .section-heading');
  const words=shown.map(x=>'<strong>'+esc(x.to)+'</strong> in place of '+esc(x.from));
  const list=words.length>1?words.slice(0,-1).join(', ')+' and '+words.at(-1):words[0];
  const note='<aside class="swap-notice" role="note"><span class="t-label t-label--brass">'+(shown.length>1?'Two swaps':'A swap')+' just now</span>'
    +'<p>This hamper comes with '+list+', '+(shown.length>1?'each':'')+' of equal or higher value, because '
    +(shown.length>1?'those are':'it is')+' unavailable just now. Everything else is as listed.</p></aside>';
  if(head)head.insertAdjacentHTML('afterend',note);
  document.documentElement.classList.add('has-swaps');
})();

/* One detail dialog for every real item in the hamper. */
(() => {
  const data=document.getElementById('ingredients-data');
  const dialog=document.getElementById('ingredient-dialog');
  if(!data || !dialog) return;
  const {items,hamper}=JSON.parse(data.textContent);
  const q=id=>document.getElementById(id);
  let index=0, returnFocus=null, overflow='', token=0, fromPop=false, ownsEntry=false, active=false, closingPhoto=false;
  const hashIndex=()=>items.findIndex(item=>item.handle===new URLSearchParams(location.hash.slice(1)).get('inside'));
  const card=i=>document.querySelector('.ingredient-card[data-ingredient="'+i+'"]');
  function paint(i,writeURL=true){
    index=(i+items.length)%items.length;
    const item=items[index], request=++token;
    q('ingredient-title').textContent=item.name;
    q('ingredient-amount').textContent=item.amount;
    q('ingredient-description').textContent=item.description;
    q('ingredient-hamper').textContent=hamper;
    q('ingredient-included').textContent='Included in '+hamper+'.';
    q('ingredient-position').textContent=(index+1)+' / '+items.length;
    q('ingredient-previous').textContent=items[(index-1+items.length)%items.length].name;
    q('ingredient-next').textContent=items[(index+1)%items.length].name;
    dialog.dataset.current=item.handle;
    dialog.querySelector('.ingredient-stage').classList.toggle('is-scene',item.kind==='scene');
    dialog.querySelector('.ingredient-stage').classList.toggle('is-swap',item.kind==='swap');
    const img=q('ingredient-photo');
    // 20 Oct 2026 (the phone journeys): on an iPhone the dialog opened with an empty stage. It asked for the photo
    // by its bare address while the card beside it had the same photo under a ?v= address, so it was fetched again
    // from cold and held at opacity 0 until decoded. The card's own photo, already on screen, is now drawn at once,
    // and the full-size one takes its place when it has decoded. With no card photo yet (lazy, never scrolled to)
    // it is as before.
    const near=card(index)?.querySelector('img');
    const ready=near&&near.complete&&near.naturalWidth>0?near.currentSrc:'';
    const path=u=>String(u||'').split('?')[0].replace(/^https?:/,'');
    img.alt=item.name;
    if(ready){
      img.style.opacity='1'; img.src=ready;
      if(path(ready)!==path(item.image)){
        const full=new Image(); full.src=item.image;
        full.decode().then(()=>{if(request===token)img.src=item.image;}).catch(()=>{});
      }
    }else{
      img.style.opacity='0'; img.src=item.image;
      img.decode().then(()=>{if(request===token)img.style.opacity='1';}).catch(()=>{if(request===token)img.style.opacity='1';});
    }
    dialog.querySelector('.ingredient-dialog-body').scrollTop=0;
    document.querySelectorAll('[data-ingredient]').forEach(el=>el.setAttribute('aria-expanded',String(Number(el.dataset.ingredient)===index && dialog.open)));
    if(writeURL)history.replaceState(history.state,'','#inside='+encodeURIComponent(item.handle));
    // Warm only the adjacent item; the whole catalogue is not downloaded for
    // one detail view. The 360px card images already cover initial browsing.
    const next=new Image();next.src=items[(index+1)%items.length].image;
  }
  function open(i,trigger,historyNavigation=false){
    if(!dialog.open){
      returnFocus=trigger||card(i); overflow=document.body.style.overflow;
      if(!historyNavigation){
        history.pushState({...history.state,admIngredient:true},'','#inside='+encodeURIComponent(items[i].handle));
        ownsEntry=true;
      }else ownsEntry=history.state?.admIngredient===true;
      dialog.showModal();active=true;document.body.style.overflow='hidden';
      dialog.querySelector('[data-close-ingredient]').focus({preventScroll:true});
    }
    paint(i,!historyNavigation);
  }
  document.querySelectorAll('[data-ingredient]').forEach(trigger=>trigger.addEventListener('click',e=>{
    if(e.metaKey||e.ctrlKey||e.altKey||e.shiftKey)return;
    e.preventDefault();open(Number(trigger.dataset.ingredient),trigger);
  }));
  function finish(){
    if(!active)return;
    active=false;++token;document.body.style.overflow=overflow;
    document.querySelectorAll('[data-ingredient]').forEach(e=>e.setAttribute('aria-expanded','false'));
    returnFocus?.focus({preventScroll:true});
    if(fromPop){fromPop=false;return;}
    if(ownsEntry){ownsEntry=false;history.back();}
    else if(hashIndex()>=0)history.replaceState(history.state,'',location.pathname+location.search);
  }
  function close(){
    dialog.close();finish();
  }
  dialog.querySelectorAll('[data-close-ingredient]').forEach(b=>b.addEventListener('click',close));
  dialog.addEventListener('cancel',e=>{e.preventDefault();close();});
  dialog.querySelectorAll('[data-ingredient-step]').forEach(b=>b.addEventListener('click',()=>paint(index+Number(b.dataset.ingredientStep))));
  dialog.addEventListener('keydown',e=>{
    if(e.key==='Tab'){
      const buttons=[...dialog.querySelectorAll('button:not([disabled])')].filter(b=>b.getClientRects().length);
      const first=buttons[0],last=buttons.at(-1);
      // Native dialogs make the page inert, but some engines still tab from
      // the final button into browser chrome. Keep the discovery loop here.
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    }
    if(e.key==='ArrowLeft'||e.key==='ArrowRight'){
      e.preventDefault();paint(index+(e.key==='ArrowRight'?1:-1));
    }
  });
  dialog.addEventListener('click',e=>{
    const r=dialog.getBoundingClientRect();
    if(e.target===dialog&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))close();
  });
  dialog.addEventListener('close',()=>{
    // Cleanup is synchronous for our actions. A queued close event from the
    // previous view must not unlock or refocus a quickly reopened dialog.
    if(!dialog.open)finish();
  });
  function followHistory(){
    if(closingPhoto)return;
    const photo=q('photo-dialog');
    if(dialog.open&&photo?.open){
      // The nested viewer restores its own scroll state in a queued close
      // event. Finish that first, then follow the most recent history entry.
      closingPhoto=true;
      photo.addEventListener('close',()=>{closingPhoto=false;followHistory();},{once:true});
      photo.close();return;
    }
    const next=hashIndex();
    if(next>=0)open(next,card(next),true);
    else if(dialog.open){fromPop=true;close();}
  }
  addEventListener('popstate',followHistory);
  q('ingredient-zoom').addEventListener('click',()=>{
    const item=items[index];
    DeliGallery.open([{id:'01',src:item.image,label:item.name,alt:item.name}],0,q('ingredient-zoom'),'catalogue');
  });
  document.documentElement.classList.add('ingredients-ready');
  const requested=hashIndex();if(requested>=0)open(requested,card(requested),true);
})();
